import React from 'react';
import { UiText, UiGrid, UiCard } from '../..';
export function ExampleText() {
    return (React.createElement(UiCard, { contentPadding: 2 },
        React.createElement(UiGrid, null, [4, 3, 2, 1, 0, -1, -2].map(function (size) { return (React.createElement(UiText, { size: size, key: size },
            "Size: ",
            size,
            " ",
            size === 0 && React.createElement(React.Fragment, null, "(Default)"),
            React.createElement("br", null),
            "Additional line for line-height",
            React.createElement("br", null),
            "Additional line for line-height")); }))));
}
